import { inView, animate, scroll, stagger } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const blockTextMedia = document.querySelectorAll('.block-text-media');

    // Check if any blockTextMedia elements exist
    if (blockTextMedia.length === 0) {
        return;
    }

    blockTextMedia.forEach(blockTextMedia => {
        const blockTextMediaContentText = blockTextMedia.querySelector('.block-text-media__content__text');
        const blockTextMediaContentMedia = blockTextMedia.querySelector('.block-text-media__content__media');
        
        // Ensure blockTextMediaContent exists
        inView(blockTextMedia, () => {
            if(blockTextMediaContentText) {
                animate(blockTextMediaContentText, 
                    { 
                        opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
                        // transform: ['translateY(40px)', 'translateY(0)'], // Slight upward movement.
                    },
                    { 
                        duration: 0.6, // Animation duration.
                        delay: 0.3
                    }
                );
            }
            if(blockTextMediaContentMedia) {
                animate(blockTextMediaContentMedia, 
                    { 
                        opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
                        transform: ['translateX(40px)', 'translateY(0)'], // Slight upward movement.
                    },
                    { 
                        duration: 0.6, // Animation duration.
                        delay: 0.6
                    }
                );
                scroll(
                    animate(blockTextMediaContentMedia.querySelector('img'),
                        { y: [50, -300] },  // Move the heading from 50 to -400px along the Y-axis.
                        { ease: "ease-in-out" } // Easing.
                    )
                );
            }
        });
    });
});